export default "/images/vendor/@coreui/icons/svg/flag/cif-tn.svg?0ad5334779ec0f4d0f101913ab28a166";